// extracted by mini-css-extract-plugin
module.exports = {"entry":"Profile_entry__2Eo8P","profilePicture":"Profile_profilePicture__3P3de","details":"Profile_details__1jFrh"};